<meta charset="utf-8">
<style type="text/css">

* { padding:0; margin:0; line-height: 1.5; font-weight: 400; }
.ituFooterQuicklinks { margin: 0.5rem 0; padding-top: 0.5rem; border-top: 1px solid rgba(112,112,112,.3); }
.footer-nav-list { 
	display: flex;
	justify-content: space-around;
	list-style: none;
}
.footer-nav-list .list_item .link { color:#0076a1; text-decoration: none; }
.footer-nav-list .list_item:hover .link { color:#009cdd; }
.ituCopyright {
	text-align: center;
    font-size: .75rem;
    color: #6e6e6e;
    padding: 0.5rem 0;
}
footer {
    margin-top: auto;  
    padding-top: 0.5rem;
    padding-bottom: 0;
    background-color: #f1f1f1;  
}
</style>



<footer class="footer">
    <div class="ituFooterQuicklinks">
        <ul class="footer-nav-list">
            <li class="list_item"><a href="https://www.itu.int/en/about/Pages/contact.aspx" class="link">Contact us</a></li>
            <li class="list_item"><a href="https://www.itu.int/en/ethics/Pages/helpline.aspx" class="link">Ethics/report misconduct</a></li>
            <li class="list_item"><a href="https://www.itu.int/en/Pages/accessibility.aspx" class="link">Accessibility</a></li>
            <li class="list_item"><a href="https://www.itu.int/en/about/Pages/privacy-notice.aspx" class="link">Privacy notice</a></li>
        </ul>
    </div>
    <div class="ituCopyright">© 2026 ITU. All rights reserved</div>
</footer>
